import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store";
import { updateDatasetStep } from "../../store/reducers/DatasetReducer";
import SystemMsg from "../SystemMsg";
import ScrewDropdownProps from "../DropdownProps/ScrewDropdownProps";
import { resetScrewUpload } from "../../store/reducers/ScrewsReducers";
import { addScrewsToDatasetAction } from "../../store/actions/ScrewsActions";
import {
  getUploadedScrewData,
  getScrewUploadStatus,
  getScrewProperties,
  getUploadedScrewStatus,
} from "../../store/selectors/ScrewSelectors";

const ScrewDetails = () => {
  const dispatch = useAppDispatch();
  const screwUploadStatus = useAppSelector(getScrewUploadStatus);
  const addScrewStatus = useAppSelector(getUploadedScrewStatus);
  const uploadedScrewData = useAppSelector(getUploadedScrewData);
  const screwProperties = useAppSelector(getScrewProperties);
  const [screwDraft, updateScrewDraft] = useState<any>({
    sampleids: uploadedScrewData?.map(sample => sample.sampleid) || [],
    imagepaths: uploadedScrewData?.map(sample => sample.imagepath) || [],
  });

  const isNextStepDisabled = !screwProperties?.items
    ?.filter(prop => prop.islabel)
    .every(prop => screwDraft[prop.propertyname] && screwDraft[prop.propertyname] !== "");

  const onAddToDataset = () => {
    const formBody = new URLSearchParams();
    // Send multiple sample_ids parameters for each sample ID
    screwDraft.sampleids.forEach((sampleId: string) => {
      formBody.append('sample_ids', sampleId);
    });
    formBody.append('categoricalvalue', screwDraft.ref);

    dispatch(addScrewsToDatasetAction(formBody.toString()));
  };

  useEffect(() => {
    if (addScrewStatus === "success") {
      dispatch(updateDatasetStep(3));
    }
  }, [addScrewStatus, dispatch]);

  const onCancelScrewProcessing = () => {
    dispatch(resetScrewUpload());
    dispatch(updateDatasetStep(1));
  };
  

  const screwComponent = (
    <div className="screw-wrapper">
      <div className="nav-controls">
        <div className="left-side">
          <Button onClick={onCancelScrewProcessing}>Back</Button>
        </div>
      </div>
      <div className="screw-details">
        <div className="left-side">
          <div className="screw-images">
            {uploadedScrewData?.map((sample, index) => (
              <div key={sample.sampleid} className="screw-img">
                <img src={sample.imagepath} alt={`Screw ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
        <div className="right-side">
          <h2>Data labels</h2>
          <p className="upload-info">Properties will be applied to all {uploadedScrewData?.length || 0} uploaded screws</p>
          {screwProperties?.items
            ?.filter(prop => prop.islabel)
            .map(prop => (
              <ScrewDropdownProps
                key={prop.propertyid}
                onChooseScrewProperty={(evt: any) => {
                  updateScrewDraft({ ...screwDraft, [prop.propertyname]: evt.target.value });
                }}
                selectedScrewProperty={screwDraft[prop.propertyname]}
                propertyType={prop.propertyname}
              />
            ))}
          <div className="screw-details-controls">
            <div className="row">
              <Button
                variant="contained"
                className="btn btn-blue"
                onClick={onAddToDataset}
                disabled={isNextStepDisabled}
              >
                Add {uploadedScrewData?.length || 0} screws to dataset
              </Button>
            </div>
            <div className="row">
              <Button
                className="btn btn-outlined"
                variant="outlined"
                onClick={onCancelScrewProcessing}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  if (addScrewStatus === "error") {
    return <SystemMsg messageType="error" message="Failed to add screws to dataset" />;
  }

  return screwUploadStatus === "error" ? <SystemMsg /> : screwComponent;
};

export default ScrewDetails;
